export default {"src":"/_next/static/media/HeaderMenIcon2.e79b1fb1.svg","height":72,"width":71,"blurWidth":0,"blurHeight":0};